// extracted by mini-css-extract-plugin
export default {"button":"UiButton_button__wmJc4","dark":"UiButton_dark__S7xdY","light":"UiButton_light__yXhH8"};